import { gql } from '@apollo/client';

export const GET_FARM_DATA_BY_ID = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetContentDetailsRequest!
	) {
		getContentDetails(input: $input) {
			ResponseStatus {
				status
				statusReason
				errorCode
				internalErrorCode
			}
			contentResponse {
				CMSResponse {
					GeoDataSource
					PlaceId
					ContentResponse {
						contentMetaData {
							contentURL
							contentId
							approvalStatus
							metaData {
								placeId
								referralPhoneNo
								programName
								timestamp {
									seconds
									nanos
								}
								accuracy
								latitude
								longitude
								geofencingStatus
								PlaceSourceType
								rejectionReasons
							}
						}
					}
				}
				UserFarmResponse {
					PlaceId
					farmServiceResponse {
						farm {
							farmerId
							acres
							childrenFarms {
								acres
								farmBoundary {
									placeId
								}
							}
							farmBoundary {
								placeId
							}
						}
					}
				}
			}
		}
	}
`;

export const GET_REJECTION_REASONS = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_RejectionReasonRequest
	) {
		getRejectionReasons(input: $input) {
			ResponseStatus {
				status
				statusReason
				reasons
				errorCode
				errorMessages
				internalErrorCode
			}
			RejectionReason
		}
	}
`;

export const GET_CONTENT_DETAILS_BY_FARM_ID = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetContentDetailsRequestV3
	) {
		getContentDetailsV3(input: $input) {
			ResponseStatus {
				status
				statusReason
				errorCode
				internalErrorCode
			}
			placeContentDetails {
				place {
					geometry
					tags {
						TagName
						TagPropertyKey
						value {
							valueType
							stringValues
							int64Values
							boolValues
							floatValues
							int32Values
							nsvPlaceIdValues {
								PlaceNamespace
								PlaceSourceType
								PlaceVisibleType
								placeId
							}
							overlappingPlaceValues {
								overlapContext {
									cropSeason
									appName
								}
								overlapPercentage
								placeId
							}
						}
					}
					timeRange {
						startTime {
							seconds
						}
						endTime {
							seconds
						}
					}
					referenceAttributes {
						referenceType
						attributes {
							key
							value {
								valueType
								int64Value
								boolValue
								stringValue
							}
						}
					}
					representationType
					sourceId
					placeId
					deleted
					overlap
				}
				placeContentMeta {
					height
					width
					contentId
					contentURL
					approvalStatus
					placeId
					timestamp {
						seconds
						nanos
					}
					programName
					accuracy
					latitude
					longitude
					geofencingStatus
					PlaceNamespace
					PlaceSourceType
					PlaceVisibleType
					rejectionReasons
					referralPhoneNo
				}
			}
			placeFarmDetails {
				place {
					geometry
					createdTime {
						seconds
					}
					tags {
						TagName
						TagPropertyKey
						value {
							valueType
							stringValues
							int64Values
							boolValues
							floatValues
							int32Values
							nsvPlaceIdValues {
								PlaceNamespace
								PlaceSourceType
								PlaceVisibleType
								placeId
							}
							overlappingPlaceValues {
								overlapContext {
									cropSeason
									appName
								}
								overlapPercentage
								placeId
							}
						}
						TagPropertyValue
						PlaceTagId
					}
					timeRange {
						startTime {
							seconds
						}
						endTime {
							seconds
						}
					}
					referenceAttributes {
						referenceType
						attributes {
							key
							value {
								valueType
								int64Value
								boolValue
								stringValue
							}
						}
					}
					representationType
					sourceId
					placeId
					deleted
					overlap
				}
				farmMeta {
					farmerId
					acres
					placeId
				}
			}
			contentPlaceIds
			farmPlaceIds
			parentFarmMeta {
				farmerId
				acres
				placeId
			}
		}
	}
`;

export const GET_TEMPORAL_PLACES_BY_REFERENCES = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetTemporalPlacesByReferencesRequest!
	) {
		GetTemporalPlacesByReferences(input: $input) {
			responseStatus {
				status
				statusReason
			}
			places {
				placeId
				overlap
				geometry
				representationType
				timeRange {
					startTime {
						seconds
					}
					endTime {
						seconds
					}
				}
				tags {
					TagName
					TagPropertyKey
					value {
						valueType
						boolValues
						stringValues
						floatValues
						int64Values
						int32Values
					}
				}
			}
		}
	}
`;
export const GET_DEVICE_HEALTH_STATUS = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_CheckDeviceHealthRequest!
	) {
		checkDeviceHealth(input: $input) {
			responseStatus {
				status
				statusReason
			}
			isMalfunctioned
			deviceStatus {
				uuid
				deviceId
				machineNo
				seqNo
				iotDeviceStatus
				averageFrequency
				averageDistance
				millisSinceLastPing
				timeRange {
					startTime {
						seconds
					}
					endTime {
						seconds
					}
				}
			}
		}
	}
`;
export const GET_ALL_MACHINE_IDS = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetAllMachineIdsRequest!
	) {
		getAllMachineIds(input: $input) {
			responseStatus {
				status
				statusReason
				errorMessages
			}
			machineIds
		}
	}
`;

export const GET_DEVICE_METRICS = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetProcessedMetricRequest!
	) {
		GetProcessMetric(input: $input) {
			responseStatus {
				status
				statusReason
				errorCode
				internalErrorCode
			}
			metricSummary {
				metricType
				deviceHealth {
					deviceStatus
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				accident {
					accidentStatus
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				externalPower {
					externalPowerStatus
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				ignition {
					ignitionStatus
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				battery {
					internalBatteryStatus
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				network {
					networkStatus
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				speedLimit {
					speedLimitStatus
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				towing {
					towingStatus
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				engine {
					engineStatus
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				sprayer {
					sprayerStatus
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				floatMetrics {
					value
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
				stringMetrics {
					value
					timeSlot {
						startTime {
							seconds
						}
						duration {
							seconds
						}
					}
				}
			}
		}
	}
`;
